// extracted by mini-css-extract-plugin
module.exports = {"titleBlock":"TwoFaAuth_titleBlock__aVZcB","formContainer":"TwoFaAuth_formContainer__hp2To","alreadyHaveAccount":"TwoFaAuth_alreadyHaveAccount__pACBj"};